import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 10h7","key":"svg-0"}],["path",{"d":"M3 14h7","key":"svg-1"}],["path",{"d":"M14 10h7","key":"svg-2"}],["path",{"d":"M14 14h7","key":"svg-3"}]]

/**
 * IconEqualDouble
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZXF1YWwtZG91YmxlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDEwaDciIC8+CiAgPHBhdGggZD0iTTMgMTRoNyIgLz4KICA8cGF0aCBkPSJNMTQgMTBoNyIgLz4KICA8cGF0aCBkPSJNMTQgMTRoNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/equal-double
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconEqualDouble = createReactComponent('outline', 'equal-double', 'EqualDouble', __iconNode);

export default IconEqualDouble;